import React, { Component } from 'react';
import LKModal from '../Modal/Modal';
import BlankLoader from '../Common/BlankLoader';
import './FrameAnalysis.scss';

class FrameAnalysis extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showCmsDataModal: false,
    };
    this.openModalBox = this.openModalBox.bind(this);
  }

  openModalBox = value => {
    this.setState({ showCmsDataModal: true });
    this.props.getCmsPageData(value);
  };

  close = () => {
    this.setState({ showCmsDataModal: false });
  };

  render() {
    const {
      frameSize,
      checkFaceWidthUrl,
      cmsPopUpData,
      dataLocale: { SIZE },
      localeInfo,
    } = this.props;
    const { domain } = localeInfo;
    return (
      <div className="padding-b10">
        <span className="capitalize fsp14 fs16 text-color-grey padding-t10 fw700">
          {SIZE}: {frameSize}
        </span>
        {checkFaceWidthUrl ? (
          <span
            aria-label="show frame size"
            className="cursor-pointer"
            onClick={() => {
              this.openModalBox(
                checkFaceWidthUrl.replace('https://www.lenskart.com/', '').replace(domain, '')
              );
            }}
          >
            <i className="fa fa-question-circle fs15 padding-l5"></i>
          </span>
        ) : (
          ''
        )}
        {this.state.showCmsDataModal && (
          <LKModal
            backdrop
            keyboard
            hideHandler={this.close}
            showModal={this.state.showCmsDataModal}
            size="large"
          >
            <div className="cmsdata-modal" data-testid="contentManagementData">
              <div
                aria-label="close button"
                className="close-me-btn"
                onClick={() => {
                  this.setState({ showCmsDataModal: false });
                }}
              ></div>
              {cmsPopUpData ? (
                <div dangerouslySetInnerHTML={{ __html: cmsPopUpData }}></div>
              ) : (
                <BlankLoader />
              )}
            </div>
          </LKModal>
        )}
      </div>
    );
  }
}
export default FrameAnalysis;
